<template>
  <Modal
    :id="'cmp-settings-task-template-form'"
    @cancelled="onCancel"
    :loadingFlag="loadingFlag"
  >
    <template slot="header">{{`${$t('new_task_for')} ${$t(external_table)||$t('contract_reminder')}`}}</template>

    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'task_template_name'"
          v-bind="textFieldConfig"
          :value="task_template.task_template_name"
          :placeholder="$t('task_template_name')"
          @valuechanged="onTextFieldValueChange"
        />

        <template v-if="this.external_table=='general'">
          <div class="ut-flex">
            <DTCheckbox
              v-for="(item,index) in monthsCheck1"
              :key="item+index"
              :id="item"
              :label="item"
              :checked="selectedMonth.includes(item)"
              @click="e => onCheckboxChangeMonth(item, e)"
              :minH="'42px'"
              :class="'ml0'"
            />
          </div>
          <div class="ut-flex">
            <DTCheckbox
              :key="item+index"
              v-for="(item,index) in monthsCheck2"
              :id="item"
              :label="item"
              :checked="selectedMonth.includes(item)"
              @click="e => onCheckboxChangeMonth(item, e)"
              :minH="'42px'"
              :class="'ml0'"
            />
          </div>
          <DTCheckbox
            
            :id="'end_of_month'"
            :label="$t('end_of_month')"
            :checked="end_of_month==1||end_of_month=='1'"
            @click="e => onCheckboxChange('end_of_month',e)"
            :minH="'42px'"
            :class="'ml0'"
          />
        </template>


        <!-- {{ selectedMonth.toString() }} -->


        <TextField
          class="m1"
          :id="'day_shift'"
          v-bind="textFieldConfig"
          :value="task_template.day_shift"
          :placeholder="$t('day_shift')"
          @valuechanged="onTextFieldValueChange"
        />
        <Dropdown
          :options="usersTV"
          class="m2"
          :selected="assignedUserSelectedTV"
          :placeholder="$t('assigned_user')"
          v-on:selectedChange="e => onDropdownChange('assigned_user', e)"
          :listHeight="120"
          box
          multiple
        />
        <Dropdown
          :options="usersTV"
          class="m2"
          :selected="usersTV.find(t => t.value == task_template.sent_user)"
          :placeholder="$t('sent_user')"
          v-on:selectedChange="e => onDropdownChange('sent_user', e)"
          :listHeight="120"
          box
        />

        <template v-for="(item,index) in extra_fields">
          <TextField
          
            :key="index"
            class="m1"
            :id="index"
            v-bind="textFieldConfig"
            :value="item.field_name"
            :placeholder="$t(item['field_name'])"
            @valuechanged="onExtraFieldValueChange"
            :disabled="false"
          />
          
        </template>

        <Dropdown
          v-if="external_table=='booking'"
          :options="localDetailTypesTV"
          class="m2"
          :selected="localDetailsTypeSelectedTV"
          :placeholder="$t('display_local_details')"
          v-on:selectedChange="e => onDropdownChange('local_detail_type_ids', e)"
          :listHeight="120"
          box
          multiple
        />

        <DTCheckbox
          v-if="external_table=='booking'"
          :id="'travel'"
          :label="$t('show_travel')"
          :checked="task_template.travel == '1'||task_template.travel == 1"
          @click="e => onCheckboxChange('travel', e)"
          :minH="'42px'"
          :class="'ml0'"
          style="margin-left: -10px;margin-top: 0px;margin-bottom: 0px;"
        />

        <DTCheckbox
          v-if="external_table=='booking'"
          :id="'delete_on_cancel'"
          :label="external_table=='booking' ? $t('delete_task_if_artist_is_cancelled') : $t('Delete Task if Inactive')"
          :checked="task_template.delete_on_cancel == '1'||task_template.delete_on_cancel == 1"
          @click="e => onCheckboxChange('delete_on_cancel', e)"
          :minH="'42px'"
          :class="'ml0'"
          style="margin-left: -10px;margin-top: 0px;margin-bottom: 0px;"
        />
        
        <template v-if="external_table!='booking'">

          <ExtraField @onAdd="onAddExtraField" style="margin-top:20px"/>
        </template>


          <!-- {{ extra_fields }} -->

      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{ $t('cancel') }}</button>
      <button class="dt-button v1 s6" @click.stop="onTaskTemplateSubmit">
        {{ $t("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { BookingSettingsService } from "../../services/booking-settings.service";
import ExtraField from "./extra-field.vue";
import DTCheckbox from "@plugins/checkbox/checkbox";
import { uuidv4 } from "../../../../utility";
export default {
  components: {
    Modal,
    ExtraField,
    DTCheckbox
  },
  props: {},
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false
      },
      task_template: this.getTaskTemplate(),
      submitted: false,
      formData: {},
      extra_fields:[],
      monthsCheck1:['M1','M2','M3','M4','M5','M6'],
      monthsCheck2:['M7','M8','M9','M10','M11','M12'],
      end_of_month:1,
      selectedMonth:[]

    };
  },
  mounted: async function() {
    const formData = await BookingSettingsService.findBookingTaskTemplateFormData({ task_template_id: this.task_template_id });
    this.formData = formData.data;
    console.log("P",this.formData)

    if (this.isEditMode) {
      this.task_template = this.formData.task_template;
      
      const JsonData = this.formData?.task_template?.json_data ? JSON.parse(this.formData.task_template.json_data):{};
      this.extra_fields = JsonData?.extra_fields ||[]
      this.end_of_month = JsonData?.end_of_month||0
      this.selectedMonth =  JsonData?.month.split(",")
      console.log("P",this.formData.task_template.json_data.extra_fields)
    } else {
      this.task_template = this.getTaskTemplate();
    }
  },
  computed: {
    external_table: function() {
      return this.$route.query.external_table;
    },
    task_template_id: function() {
      return this.$route.query.task_template_id;
    },
    mode: function() {
      return this.$route.query.mode;
    },
    isEditMode: function() {
      return this.mode == "edit";
    },
    loadingFlag: function() {
      if (this.isEditMode) {
        return !this.task_template.task_template_id;
      } else {
        return this.submitted;
      }
    },
    usersTV(){
      return (this.formData?.all_users || []).map(r => ({text: r.user_name, value: r.user_id}));
    },
    localDetailTypesTV(){
      return (this.formData?.local_detail_types || []).map(r => ({text: r.local_details_type_name, value: r.local_details_type_id}));
    },
    assignedUserSelectedTV(){
      const assignedUserArr = this.task_template?.assigned_user ? this.task_template.assigned_user.split(',') : [];
      return this.usersTV.filter( userTV => assignedUserArr.includes("" + userTV.value) ) || [];
    },
    localDetailsTypeSelectedTV(){
      const ldtArr = this.task_template?.local_detail_type_ids ? this.task_template.local_detail_type_ids.split(',') : [];
      return this.localDetailTypesTV.filter( ldtTV => ldtArr.includes("" + ldtTV.value) ) || [];
    }
  },
  methods: {

    onCheckboxChangeMonth:function(item,e){
      console.log(e.target.checked)
      const value = e.target.checked ? 1 : 0;
      if(value==1){
        this.selectedMonth.push(item);
      }else{
        const index =this.selectedMonth.indexOf(item);
        if (index > -1) { 
          this.selectedMonth.splice(index, 1); 
        }
      }
      
    },
    onTaskTemplateSubmit: function() {
      this.onCancel()
      this.submitted = true;

      let json_data = {extra_fields:[ ...this.extra_fields]}

      if(this.external_table=='general'){
          json_data = {
            ...json_data,
            end_of_month:this.end_of_month,
            month:this.selectedMonth.toString() 
          }
      }


        json_data = {
          ...json_data,
          extra_fields:this.extra_fields.map(x=>{
            return {
              ...x,
              field_data:x.field_data?x.field_data:'',
              field_UUID:x.field_UUID?x.field_UUID: uuidv4()
            }
          })
        }

      
      this.$emit("done", {
        mode: this.mode,
        task_template: { ...this.task_template , json_data:{ ...json_data } }
      });
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onExtraFieldValueChange:function(e,value){
      console.log(e,"EEEEEEE",value)

      this.extra_fields[e].field_name = value;


    },
    onTextFieldValueChange: function(id, value) {
      this.task_template[id] = value;
    },
    onDropdownChange: function(name, value) {
      let val = value.value;
      if(['assigned_user', 'local_detail_type_ids'].includes(name)){
        val = value.map(r => r.value).join();
      }
      this.task_template[name] = val;
    },
    onCheckboxChange: function(name, event) {
      
      const value = event.target.checked ? 1 : 0;

      if(name == 'end_of_month'){
        this.end_of_month =value
      }else{
        this.task_template[name] =value 
      }
      
    },
    getTaskTemplate: function() {
      return {
        task_template_name: "",
        day_shift: "",
        assigned_user: "",
        sent_user: "",
        local_detail_type_ids: "",
        travel: "",
        delete_on_cancel: "",
       
      };
    },
    onAddExtraField:function(payload){
      console.log(payload,":::::::::")
      this.extra_fields.push(payload);
    }
  }
};
</script>

<style lang="scss">
.cmp-settings-task-template-form {
  /*.dt-checkbox-control {
    display: flex;
    padding-top: 12px;
    .dt-checkbox {
      max-width: 40px;
      margin: 3px 10px 0px 0px;
    }
  }*/
  .expnad-box {
    margin-top: 15px;
    .expand-box-header {
      border-bottom-color: transparent;
      .expand-icon {
        display: none;
      }

      .expand-box-header--title {
        display: flex;
        border-right-color: transparent;
        font-weight: 400 !important;
        color: var(--bc-accent5);
        padding-left: 0;
        position: relative;
     }
    }
  }
}
</style>
